import { render } from "./Join.vue?vue&type=template&id=1c18da59&scoped=true"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"

import "./Join.vue?vue&type=style&index=0&id=1c18da59&scoped=true&lang=css"
import "@/styles/header.css?vue&type=style&index=1&id=1c18da59&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=2&id=1c18da59&scoped=true&lang=css&external"

import exportComponent from "../../../../../../Users/cole/Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c18da59"]])

export default __exports__